import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(formData.phone, formData.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || '登录失败，请重试。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #c1f0f0 0%, #f8d7da 100%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '420px',
        backgroundColor: 'white',
        borderRadius: '32px',
        padding: '40px 45px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '40px'
        }}>
          <img 
            src="/logo.png" 
            alt="123wonder英文科普" 
            style={{ 
              height: '60px', 
              width: 'auto',
              marginBottom: '25px'
            }} 
          />
          <h1 style={{ 
            marginBottom: '10px', 
            color: '#2d3436',
            fontSize: '1.75rem',
            fontWeight: '700',
            lineHeight: '1.3'
          }}>
            Let's have fun now!
          </h1>
          <p style={{ 
            color: '#636e72',
            fontSize: '1.25rem',
            fontWeight: '500',
            margin: 0
          }}>
            英语科普学习网站
          </p>
        </div>

        {error && (
          <div style={{ 
            padding: '12px 16px',
            marginBottom: '24px',
            borderRadius: '8px',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            border: '1px solid #f5c6cb',
            fontSize: '0.95rem'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px',
              color: '#2d3436',
              fontWeight: '600',
              fontSize: '1rem'
            }}>
              手机号
            </label>
            <input
              type="tel"
              name="phone"
              style={{
                width: '100%',
                padding: '16px 18px',
                borderRadius: '12px',
                border: '1px solid #e9ecef',
                backgroundColor: '#f0f4ff',
                fontSize: '1rem',
                color: '#2d3436',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              placeholder="请输入11位手机号"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px',
              color: '#2d3436',
              fontWeight: '600',
              fontSize: '1rem'
            }}>
              密码
            </label>
            <input
              type="password"
              name="password"
              style={{
                width: '100%',
                padding: '16px 18px',
                borderRadius: '12px',
                border: '1px solid #e9ecef',
                backgroundColor: '#f0f4ff',
                fontSize: '1rem',
                color: '#2d3436',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                outline: 'none'
              }}
              placeholder="请输入密码"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button 
            type="submit" 
            style={{
              width: '100%',
              padding: '16px 32px',
              background: 'linear-gradient(135deg, #a8e6cf 0%, #dcedc1 50%, #ffd3b6 100%)',
              color: '#2d3436',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(168, 230, 207, 0.3)'
            }}
            disabled={loading}
            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
            onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>

        <div style={{ 
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #e9ecef',
          textAlign: 'center'
        }}>
          <span style={{ 
            color: '#636e72',
            fontSize: '1rem',
            fontWeight: '500'
          }}>
            还没有账户？ 
          </span>
          <Link to="/register" style={{ 
            color: '#1976d2',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '1rem',
            transition: 'color 0.3s ease'
          }}>
            立即注册
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
